require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.5.2@core-js/library/modules/es7.symbol.observable.js
// module id = 353
// module chunks = 0 1